var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#002B2B",
  d: "M9.4 2 9 0H0v17h2v-7h5.6l.4 2h7V2zm3.6 8H9.64l-.4-2H2V2h5.36l.4 2H13z"
})));
export { SvgFlagOutline as ReactComponent };
export default __webpack_public_path__ + "5615c2010dc4523a5ca27285b35e4266.svg";